import axios from 'axios';
import { apiService } from './api.service';
import { extractData, handleResponse, handleApiException } from '../helpers/apiResponseHelper';

async function getCompanies(userId: number) {
  return axios
    .get(apiService.getApiUrl() + '/companies/' + userId)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

const CompanyService = {
    getCompanies
};

export default CompanyService;
